(function () {
  'use strict';

  var DIRECT_ROUTE_PATHS = {
    '/pages/deine-basis-routine': 'grundversorgung',
    '/pages/deine-energie-routine': 'energie',
    '/pages/deine-schlaf-routine': 'schlaf',
    '/pages/deine-kraft-routine': 'kraft',
    '/pages/deine-routine-fuer-aktives-gewicht': 'gewicht',
    '/pages/deine-beweglichkeits-routine': 'beweglichkeit'
  };

  var ROUTE_TAGS = {
    grundversorgung: ['need_basis', 'sub_beginner', 'sub_experienced', 'sub_overwhelmed'],
    energie: ['need_energy', 'sub_afternoon', 'sub_morning', 'sub_all_day'],
    schlaf: ['need_sleep', 'sub_racing_mind', 'sub_night_waking', 'sub_unrefreshed'],
    kraft: ['sub_strength'],
    gewicht: ['sub_weight'],
    beweglichkeit: ['sub_mobility']
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function sourceUrl() {
    var input = document.querySelector('[data-result-products-section] input[name="routine_url"], input[name="routine_url"]');
    try {
      return new URL(input && input.value ? input.value : window.location.href, window.location.origin);
    } catch (error) {
      return new URL(window.location.href);
    }
  }

  function tagsFromUrl(url) {
    var tags = [];
    var explicit = url.searchParams.get('tags');
    if (explicit) tags = tags.concat(explicit.split(','));
    url.searchParams.forEach(function (value, key) {
      if (normalize(key) === 'tags') return;
      tags = tags.concat(String(value || '').split(','));
    });
    return tags.map(normalize).filter(Boolean);
  }

  function routeFromUrl(url, tags) {
    var path = url.pathname.replace(/\/$/, '');
    if (DIRECT_ROUTE_PATHS[path]) return DIRECT_ROUTE_PATHS[path];
    var routes = Object.keys(ROUTE_TAGS);
    for (var i = 0; i < routes.length; i += 1) {
      var route = routes[i];
      if (ROUTE_TAGS[route].some(function (tag) { return tags.indexOf(tag) !== -1; })) return route;
    }
    return '';
  }

  function dietFromTags(tags) {
    if (tags.indexOf('diet_vegan') !== -1) return 'vegan';
    if (tags.indexOf('diet_veg') !== -1 || tags.indexOf('diet_vegetarian') !== -1) return 'vegetarian';
    return 'omni';
  }

  function previewThemeId(url) {
    var script = document.querySelector('script[data-dayvee-result-bundles]');
    return url.searchParams.get('preview_theme_id') || new URLSearchParams(window.location.search).get('preview_theme_id') || (script && script.getAttribute('data-dayvee-result-theme-id')) || '';
  }

  function mapUrl(page, url) {
    var result = '/collections/all?view=dayvee-family-map&page=' + page;
    var previewId = previewThemeId(url);
    if (previewId) result += '&preview_theme_id=' + encodeURIComponent(previewId);
    return result;
  }

  function parseMapPage(html, page) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var root = wrapper.querySelector('[data-dayvee-family-map]');
    var result = { families: {}, bundles: {}, page: page, pages: page };
    if (!root) throw new Error('Result bundle map markup missing');

    result.page = Number(root.getAttribute('data-current-page') || page) || page;
    result.pages = Number(root.getAttribute('data-pages') || page) || page;

    root.querySelectorAll('[data-dayvee-family-handle]').forEach(function (node) {
      var handle = normalize(node.getAttribute('data-dayvee-family-handle'));
      var family = normalize(node.getAttribute('data-dayvee-family-value'));
      if (handle && family) result.families[handle] = family;
    });

    root.querySelectorAll('[data-dayvee-result-bundle-key]').forEach(function (node) {
      var key = normalize(node.getAttribute('data-dayvee-result-bundle-key'));
      if (!key) return;
      result.bundles[key] = {
        key: key,
        handle: normalize(node.getAttribute('data-dayvee-result-bundle-handle')),
        title: node.getAttribute('data-dayvee-result-bundle-title') || '',
        url: node.getAttribute('data-dayvee-result-bundle-url') || '',
        price: node.getAttribute('data-dayvee-result-bundle-price') || '',
        image: node.getAttribute('data-dayvee-result-bundle-image') || '',
        summary: node.getAttribute('data-dayvee-result-bundle-summary') || '',
        available: node.getAttribute('data-dayvee-result-bundle-available') === 'true',
        hasOptions: node.getAttribute('data-dayvee-result-bundle-has-options') === 'true'
      };
    });

    return result;
  }

  function loadMapPage(page, url) {
    return fetch(mapUrl(page, url), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('bundle map HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) { return parseMapPage(html, page); });
  }

  function loadMaps(url) {
    return loadMapPage(1, url).then(function (first) {
      if (!first.pages || first.pages <= 1) return first;
      var requests = [];
      for (var page = 2; page <= first.pages; page += 1) requests.push(loadMapPage(page, url));
      return Promise.all(requests).then(function (pages) {
        pages.forEach(function (result) {
          Object.keys(result.families).forEach(function (handle) { first.families[handle] = result.families[handle]; });
          Object.keys(result.bundles).forEach(function (key) { first.bundles[key] = result.bundles[key]; });
        });
        return first;
      });
    });
  }

  function handleFromCard(card) {
    var direct = normalize(card.getAttribute('data-product-handle'));
    if (direct) return direct;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    try {
      var parts = new URL(link.href, window.location.origin).pathname.split('/products/');
      return normalize((parts[1] || '').split('/')[0]);
    } catch (error) {
      return '';
    }
  }

  function visibleFamilies(familyMap) {
    var families = [];
    document.querySelectorAll('[data-result-product-card]').forEach(function (card) {
      if (card.hidden || card.getAttribute('hidden') !== null) return;
      var handle = handleFromCard(card);
      var family = familyMap[handle] || '';
      if (family) families.push(family);
    });
    return families;
  }

  function desiredKeys(route, diet, tags, familyMap) {
    if (route === 'grundversorgung') return ['grundversorgung_' + diet];
    if (route === 'schlaf') return ['schlaf'];
    if (route === 'kraft') return ['kraft_core', 'kraft_comprehensive'];
    if (route === 'gewicht') return diet === 'vegan' ? [] : ['gewicht_standard'];
    if (route === 'beweglichkeit') return [diet === 'omni' ? 'beweglichkeit_omni' : 'beweglichkeit_veg'];
    if (route === 'energie') {
      var families = visibleFamilies(familyMap);
      var bFamily = families.indexOf('b_complex') !== -1 ? 'b_complex' : (families.indexOf('b12') !== -1 ? 'b12' : '');
      if (!bFamily) return [];
      return ['energie_' + (tags.indexOf('activity_high') !== -1 ? 'high' : 'standard') + '_' + bFamily];
    }
    return [];
  }

  function ensureStyle() {
    if (document.getElementById('dayvee-result-bundles-style')) return;
    var style = document.createElement('style');
    style.id = 'dayvee-result-bundles-style';
    style.textContent = [
      '.dqr__result-bundle-list{display:grid;gap:18px;min-width:0;}',
      '.dqr__result-bundle-card{display:grid;grid-template-columns:140px minmax(0,1fr);gap:22px;align-items:center;background:var(--dqr-card-bg);border:1px solid var(--dqr-border);border-radius:var(--dqr-radius);padding:22px;box-shadow:var(--dqr-shadow);}',
      '.dqr__result-bundle-card--with-routine{grid-template-columns:minmax(140px,.55fr) minmax(0,1.55fr) minmax(225px,.85fr);gap:26px;}',
      '.dqr__result-bundle-card--with-routine .dqr__result-bundle-image{width:100%;max-width:215px;}',
      '.dqr__result-bundle-rationale{min-width:0;align-self:center;}',
      '.dqr__result-bundle-offer{min-width:0;border:1px solid var(--dqr-border);border-radius:16px;padding:18px;background:var(--dqr-option-bg);}',
      '.dqr__result-bundle-card--with-routine .dqr__result-bundle-title{font-size:clamp(21px,1.9vw,27px);}',
      '.dqr__result-bundle-card--with-routine .dqr__result-bundle-bottom{align-items:stretch;flex-direction:column;gap:14px;}',
      '.dqr__result-bundle-card--with-routine .dqr__result-bundle-link{width:100%;}',
      '.dqr__result-bundle-card--with-routine .dqr__result-bundle-price{font-size:clamp(25px,2.4vw,31px);}',
      '@media(max-width:980px){.dqr__result-bundle-card--with-routine{grid-template-columns:minmax(120px,.5fr) minmax(0,1.5fr)}.dqr__result-bundle-card--with-routine .dqr__result-bundle-offer{grid-column:1/-1;}}',
      '.dqr__result-bundle-image{width:140px;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;background:var(--dqr-option-bg);overflow:hidden;border-radius:14px;color:var(--dqr-muted);font-size:12px;text-align:center;}',
      '.dqr__result-bundle-image img{width:100%;height:100%;object-fit:contain;display:block;}',
      '.dqr__result-bundle-label{margin:0 0 8px;color:var(--dqr-muted);text-transform:uppercase;letter-spacing:.12em;font-size:10px;line-height:1.4;font-weight:800;}',
      '.dqr__result-bundle-title{font-family:var(--font-heading-family);color:var(--dqr-text);font-size:clamp(24px,2.5vw,32px);line-height:1.12;font-weight:500;margin:0 0 10px;}',
      '.dqr__result-bundle-summary{color:var(--dqr-muted);font-size:14px;line-height:1.55;margin:0 0 14px;}',
      '.dqr__result-bundle-bottom{display:flex;flex-wrap:wrap;gap:12px 18px;align-items:center;}',
      '.dqr__result-bundle-price{font-family:var(--font-heading-family);color:var(--dqr-text);font-size:27px;line-height:1;}',
      '.dqr__result-bundle-link{min-height:46px;border:1px solid var(--dqr-button);border-radius:10px;background:var(--dqr-button);color:var(--dqr-button-text);padding:11px 18px;display:inline-flex;align-items:center;justify-content:center;text-align:center;text-decoration:none;font-weight:750;}',
      '@media(max-width:640px){.dqr__result-bundle-card{grid-template-columns:1fr;}.dqr__result-bundle-card--with-routine{grid-template-columns:1fr;}.dqr__result-bundle-card--with-routine .dqr__result-bundle-offer{grid-column:auto;}.dqr__result-bundle-image{width:100%;max-width:220px;margin:0 auto;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildCard(bundle, index, routineList) {
    var article = document.createElement('article');
    article.className = 'dqr__result-bundle-card';
    article.setAttribute('data-dayvee-result-bundle', bundle.key);

    var media = document.createElement('div');
    media.className = 'dqr__result-bundle-image';
    if (bundle.image) {
      var img = document.createElement('img');
      img.src = bundle.image;
      img.alt = bundle.title;
      img.loading = 'lazy';
      media.appendChild(img);
    } else {
      media.textContent = 'Bundle';
    }

    var body = document.createElement('div');
    var label = document.createElement('p');
    label.className = 'dqr__result-bundle-label';
    label.textContent = bundle.key === 'kraft_comprehensive' ? 'Deine umfassende Routine · 5 Produkte' : (bundle.key === 'kraft_core' ? 'Deine Trainingsbasis · 3 Produkte' : 'Dein empfohlenes Bundle');

    var title = document.createElement('h3');
    title.className = 'dqr__result-bundle-title';
    title.textContent = bundle.key === 'gewicht_standard' ? 'Gewichts-Routine' : bundle.title;

    body.appendChild(label);
    body.appendChild(title);

    if (bundle.summary) {
      var summary = document.createElement('p');
      summary.className = 'dqr__result-bundle-summary';
      summary.textContent = bundle.summary;
      body.appendChild(summary);
    }

    var bottom = document.createElement('div');
    bottom.className = 'dqr__result-bundle-bottom';

    var price = document.createElement('div');
    price.className = 'dqr__result-bundle-price';
    // Shopify money kann den Euro voranstellen; im Quiz zeigen wir "47,33 €".
    var displayPrice = String(bundle.price || '').trim();
    if (/^€\s*/.test(displayPrice)) {
      displayPrice = displayPrice.replace(/^€\s*/, '').trim() + ' €';
    }
    price.textContent = (bundle.hasOptions ? 'ab ' : '') + displayPrice;

    var link = document.createElement('a');
    link.className = 'dqr__result-bundle-link';
    link.href = bundle.url;
    link.textContent = 'Bundle ansehen';

    bottom.appendChild(price);
    bottom.appendChild(link);
    body.appendChild(bottom);

    // Für die Kernempfehlung die bestehenden Quiz-Erklärungstexte erhalten.
    // Wir kopieren lediglich die gefilterte Darstellung, niemals die Produktlogik.
    if (routineList) {
      var explanatoryItems = routineList.cloneNode(true);
      explanatoryItems.removeAttribute('hidden');
      explanatoryItems.removeAttribute('data-dqr-routine-fallback');
      var rationale = document.createElement('div');
      rationale.className = 'dqr__result-bundle-rationale';
      rationale.appendChild(explanatoryItems);
      body.classList.add('dqr__result-bundle-offer');
      article.classList.add('dqr__result-bundle-card--with-routine');
      article.appendChild(media);
      article.appendChild(rationale);
      article.appendChild(body);
    } else {
      article.appendChild(media);
      article.appendChild(body);
    }
    return article;
  }

  function renderBundles(bundles) {
    var root = document.querySelector('[data-dayvee-result-bundle-managed]');
    if (!root) return;
    root.querySelectorAll('[data-dayvee-result-bundle-list]').forEach(function (list) { list.remove(); });
    var routine = root.querySelector('.dqr__routine .dqr__inner');
    var original = routine ? routine.querySelector('.dqr__routine-card') : null;
    var core = bundles.filter(function (bundle) { return bundle.key !== 'kraft_comprehensive'; });
    var final = bundles.filter(function (bundle) { return bundle.key === 'kraft_comprehensive'; });
    // Einzelprodukte werden bei vorhandenem Bundle als Alternative, nicht
    // als notwendiger Zusatzkauf dargestellt. Ohne Bundle eigene Empfehlungen.
    var productHeading = root.querySelector('[data-result-products-section] .dqr__heading');
    if (productHeading) {
      productHeading.textContent = bundles.length
        ? 'Produkte deiner Routine – auch einzeln erhältlich'
        : 'Deine Produktempfehlungen';
    }
    if (original) original.hidden = core.length > 0;
    function insertList(target, items, before, explanatoryList) {
      if (!target || !items.length) return;
      var list = document.createElement('div');
      list.className = 'dqr__result-bundle-list';
      list.setAttribute('data-dayvee-result-bundle-list', '');
      items.forEach(function (bundle, index) { list.appendChild(buildCard(bundle, index, explanatoryList)); });
      target.insertBefore(list, before || target.firstChild);
    }
    var explanation = original ? original.querySelector('[data-dqr-routine-fallback]') : null;
    insertList(routine, core, original, explanation);
    var finalSection = root.querySelector('.dqr__final');
    if (finalSection) {
      finalSection.querySelectorAll('.dqr__final-bundle').forEach(function (card) { card.hidden = true; });
      // Der Abschlussbereich enthält auch das E-Mail-Formular.
      // Ohne Abschluss-Bundle darf dieser Bereich nicht verschwinden.
      finalSection.hidden = false;
      insertList(finalSection.querySelector('.dqr__final-grid'), final);
    }
  }

  var runId = 0;
  var mapsPromise;
  function run(event) {
    var pages = event && event.detail && event.detail.bundleMapPages;
    if (pages && pages.length) {
      mapsPromise = Promise.resolve().then(function () {
        var maps = { families: {}, bundles: {} };
        pages.forEach(function (html, index) {
          var page = parseMapPage(html, index + 1);
          Object.keys(page.families).forEach(function (handle) { maps.families[handle] = page.families[handle]; });
          Object.keys(page.bundles).forEach(function (key) { maps.bundles[key] = page.bundles[key]; });
        });
        return maps;
      });
    }
    var url = sourceUrl();
    var tags = tagsFromUrl(url);
    var route = routeFromUrl(url, tags);
    if (!route) return;
    var currentRun = ++runId;
    var mailRoot = document.querySelector('[data-dayvee-result-bundle-managed]');
    if (mailRoot) mailRoot.removeAttribute('data-dayvee-mail-ready-url');
    if (!mapsPromise) mapsPromise = loadMaps(url).catch(function (error) {
      mapsPromise = null;
      throw error;
    });
    mapsPromise.then(function (maps) {
      if (currentRun !== runId) return;
      var diet = dietFromTags(tags);
      var keys = desiredKeys(route, diet, tags, maps.families);
      var bundles = keys.map(function (key) { return maps.bundles[key]; }).filter(function (bundle) { return bundle && bundle.available; });
      renderBundles(bundles);
      var mailRoot = document.querySelector('[data-dayvee-result-bundle-managed]');
      if (mailRoot) mailRoot.setAttribute('data-dayvee-mail-ready-url', url.toString());
    }).catch(function (error) {
      console.error('[Dayvee] Result bundles:', error);
    });
  }

  function start() {
    ensureStyle();
    document.addEventListener('dayvee:result-products-ready', run);
    document.addEventListener('shopify:section:load', function () {
      var section = document.querySelector('[data-result-products-section]');
      if (!section || section.getAttribute('data-dayvee-result-ready') === 'true') run();
    });
    var section = document.querySelector('[data-result-products-section]');
    if (!section || section.getAttribute('data-dayvee-result-ready') === 'true') run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


